import { preRequisitesDocumentList } from "constants/preRequisitesDocument";


const initialState = {
  preRequisitesDocumentList: {},
};

const preRequisitesDocument = (state = initialState, action) => {
  switch (action.type) {
    case preRequisitesDocumentList:
      return { ...state, preRequisitesDocumentList: action.payload };

    default:
      return state;
  }
};

export default preRequisitesDocument;
